import Service from './service';
import { getServicesUrl } from '../../setup';

class MemberManagement extends Service {
    static getMemberPicture(memberId) {
        return Service.getRequest(
            `${getServicesUrl()}/members/${memberId}/profilepicture`,
            { isSecure: true },
        );
    }

    static deleteMemberPicture(memberId) {
        return Service.deleteRequest(
            `${getServicesUrl()}/members/${memberId}/profilepicture`,
            { isSecure: true },
        );
    }
}

export default MemberManagement;
